// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"7afab3c0aa0ccb1c2f6c","883":"787f0455740341b6d6c1","954":"29cd0f3625093023b156"}[chunkId] + ".js";
};